import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=714721de"
import script from "./IdCard.vue?vue&type=script&lang=ts"
export * from "./IdCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports